import { IAudio, IDraftAudio, IDraftImage, ITask } from '../../types/tasks.types'

const computeTasksDiff = (updated: ITask, prev: ITask) => {
  const prevImages = filterDraftImages(prev.images)
  const updatedImages = filterDraftImages(updated.images)
  const removedImages = prevImages.filter((i) => !updatedImages.includes(i))
  const createdImages = filterImages(updated.images)

  const prevOptions = prev.answerOptions.map((o) => o.id).filter(Boolean)
  const updatedOptions = updated.answerOptions.map((o) => o.id).filter(Boolean)
  const removedOptions = prevOptions.filter((o) => !updatedOptions.includes(o))
  const createdOptions = updated.answerOptions.filter((o) => !o.id)

  const isAudioUpdated = updated.audio[0] instanceof File
  const isAudioRemoved = !updated.audio[0] && prev.audio[0]

  const prevTaskAudio = filterDraftAudio(prev.audio as any)
  const updatedTaskAudio = filterDraftAudio(updated.audio as any)
  const removedTaskAudio = prevTaskAudio.filter((i) => !updatedTaskAudio.includes(i))
  const createdTaskAudio = filterAudio(updated.audio as any)

  return {
    images: {
      created: createdImages,
      removed: removedImages,
    },
    answerOptions: {
      created: createdOptions,
      removed: removedOptions,
    },
    audio: {
      removed: ((isAudioUpdated || isAudioRemoved ? [prev.audio[0]] : []) as IAudio[]).filter(Boolean),
      created: isAudioUpdated ? createdTaskAudio : [],
    },
    taskAudio: {
      created: createdTaskAudio,
      removed: removedTaskAudio,
    },
  }
}

const filterImages = (images: ITask['images']): IDraftImage[] => {
  return images
    .map((i) => {
      if (!('imageFile' in i)) return null
      return i
    })
    .filter(Boolean)
}

const filterDraftImages = (images: ITask['images']) => {
  return images
    .map((i) => {
      if ('imageFile' in i) return null
      return i.id
    })
    .filter(Boolean)
}

const filterDraftAudio = (audio: IDraftAudio[] | IAudio[]): Array<IAudio['id']> => {
  return audio
    .map((a) => {
      if (a.file instanceof File) return null

      if (!a?.id) return null
      return a.id
    })
    .filter(Boolean)
}

const filterAudio = (audio: IDraftAudio[] | IAudio[]): IDraftAudio[] => {
  return audio
    .map((a) => {
      if (a.file instanceof File) {
        return a
      }

      return null
    })
    .filter(Boolean)
}

const tasksUtils = { computeTasksDiff }

export default tasksUtils
